import React from 'react'
import { IconWarning, Paragraph, Text } from 'suomifi-ui-components'
import { NonEditableField } from 'todistukset-ui/src/vtj/components/order-wizard/CommonFormComponents.sc'
import { InfoItemRow } from 'todistukset-ui/src/vtj/components/order-wizard-aet-shared/InfoItem.sc'

const InfoItem: React.FC<{
  title: string
  content: string | string[]
  extraInfo?: string
  notImplemented?: boolean
  testIdPrefix?: string
}> = ({
  title,
  content,
  extraInfo,
  notImplemented = false,
  testIdPrefix = '',
}) => {
  const contentRows =
    typeof content === 'string'
      ? content
      : content.map((c, i) => <InfoItemRow key={i}>{c}</InfoItemRow>)
  return (
    <NonEditableField>
      <Paragraph>
        <Text variant="bold" data-test-id={`info-item-${testIdPrefix}-title`}>
          {title}
        </Text>
      </Paragraph>
      <Paragraph data-test-id={`info-item-${testIdPrefix}-content`}>
        {notImplemented && <IconWarning />}
        {contentRows}
        {extraInfo && (
          <Text color="depthDark2" smallScreen>
            &nbsp;{extraInfo}
          </Text>
        )}
      </Paragraph>
    </NonEditableField>
  )
}

export default InfoItem
